export { default } from './HeadingSeller';